import { Avatar } from "@/ui";
import { useEngineQuery } from "@/engine/hooks";
import { useOpenContact } from "@/app/navigation";
import type { ContactRow } from "@hub/shared";
import s from "../shared.module.css";

/** Avatar plus name; clicking opens the person. Pass `row` to skip the lookup. */
export function ContactChip({ contactId, size = "sm", row, onClick }: { contactId: string; size?: "sm" | "md"; row?: ContactRow; onClick?: () => void }) {
  const open = useOpenContact();
  const q = useEngineQuery("getContactRows", { contactIds: [contactId] }, { enabled: !row });
  const r = row ?? q.data?.[0];
  const name = r?.displayName ?? "Loading";
  return (
    <button type="button" className={s.chip} data-size={size} onClick={onClick ?? (() => open(contactId))} title={r?.headline ?? name}>
      <Avatar name={name} src={r?.avatarUrl} size={size === "sm" ? 20 : 26} tier={r?.bucket} seed={contactId} />
      <span className="u-truncate">{name}</span>
    </button>
  );
}
